exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sawLbOtQhH3t3T{margin:0}._2hhNapLeaiWtjW{margin-top:10px}._2hhNapLeaiWtjW a{cursor:pointer;text-decoration:underline}._3Xi7lxO8MRQuji{padding:50px 20px}.HurMAZSqXpfyXN{margin-top:32px;display:flex}._1ojyM_WiVaeDtW,._2Y-pCds17ZiRiu{border:1px solid;margin:8px 0;padding:8px}._2Y-pCds17ZiRiu{border-color:#b7ddb0;background-color:#eef6ec}._2sm7YIMVTpnbOW{border:1px solid;margin:8px 0;padding:8px;border-color:#c1c7d0;background-color:#ebecf0;color:#5e6c84}._3tPRxEvNjqSVAj{font-size:14px;line-height:20px;margin-right:8px}", ""]);

// exports
exports.locals = {
	"container": "sawLbOtQhH3t3T",
	"item": "_2hhNapLeaiWtjW",
	"itemText": "_3Xi7lxO8MRQuji",
	"section": "HurMAZSqXpfyXN",
	"email": "_1ojyM_WiVaeDtW",
	"primaryEmail": "_2Y-pCds17ZiRiu",
	"secondaryEmail": "_2sm7YIMVTpnbOW",
	"inlineIcon": "_3tPRxEvNjqSVAj"
};